<template>
    <button
        :class="buttonClass"
        @click="buttonClick"
        @mousedown="active = true"
        @mouseup="active = false"
    >
        <template v-if="showIcon">
            <StreamlineIcon
                class="ButtonDropdownOption__icon"
                :icon="option.icon"
                :size="iconSize"
                :stroke="iconColor"
            />
        </template>
        {{ option.label }}
    </button>
</template>
<script>
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import isEmpty from 'lodash/isEmpty';
import has from 'lodash/has';

export default {
    name: 'ButtonDropdownOption',
    components: {
        StreamlineIcon
    },
    props: {
        option: {
            type: Object,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: false
        },
        showSelection: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        }
    },
    data(){
        return {
            active: false
        };
    },
    computed: {
        buttonClass(){
            return `ButtonDropdownOption ${this.showSelection && this.isActive && 'ButtonDropdownOption--active'}`;
        },
        showIcon(){
            return !isEmpty(this.option.icon);
        },
        iconSize(){
            return has(this.option, 'iconSize') ? this.option.iconSize : 12;
        },
        iconColor(){
            if(this.active) {
                return '#FFFFFF';
            }
            return has(this.option, 'iconColor') ? this.option.iconColor : '#1B3449';
        }
    },
    methods: {
        buttonClick(){
            this.$emit('click', this.isActive
                ? this.required ? this.option.value : ''
                : this.option.value);
        }
    }
};
</script>
<style lang="scss" scoped>
    .ButtonDropdownOption {
        background: $white;
        display: flex;
        align-items: center;
        padding: 0.5rem;
        cursor:pointer;
        color: $grey-600;
        border-radius: 4px;
        border: 1px solid transparent;
        white-space: nowrap;
        margin-bottom:1px;

        &:hover {
            background: $grey-50;
        }
        &:focus {
            outline: none;
            box-shadow: 0 0 4px $primary;
        }
        &:active {
            outline: none;
            color: $white;
            background: #0A68F2;
        }
        &__icon {
            margin: auto 0.25rem auto 0;
        }
        &--active {
            outline: none;
            color: $white;
            background: $primary;
            &:hover {
                background: $primary;
            }
        }
    }
</style>
